import { useEffect, useRef, useState } from 'react';
import { Pause, Play, RotateCcw, ShieldCheck } from 'lucide-react';
import PrecisionReaction from './ReactionGame';
import PrecisionSearch from './SearchGame';
import PrecisionTracking from './TrackingGame';
import PrecisionMemory from './MemoryGame';
import PrecisionNBack from './NBackGame';
import PrecisionMaze from './MazeGame';
import PrecisionMatch from './MatchGame';
import type { PrecisionProps } from './types';
import { tierLabel } from './rules';

export default function PrecisionSession(props: PrecisionProps) {
  const [count, setCount] = useState(3);
  const [interrupted, setInterrupted] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const blocked = useRef(false);
  useEffect(() => {
    if (interrupted || count === 0) return;
    const timer = setTimeout(() => setCount(v => v - 1), 800);
    return () => clearTimeout(timer);
  }, [count, interrupted]);
  useEffect(() => {
    const interrupt = () => { blocked.current = true; setInterrupted(true); };
    const visibility = () => { if (document.hidden) interrupt(); };
    document.addEventListener('visibilitychange', visibility);
    window.addEventListener('blur', interrupt);
    window.addEventListener('precision-rest', interrupt);
    return () => { document.removeEventListener('visibilitychange', visibility); window.removeEventListener('blur', interrupt); window.removeEventListener('precision-rest', interrupt); };
  }, []);
  const restart = () => { blocked.current = false; setAttempt(v => v + 1); setCount(3); setInterrupted(false); };
  const Game = props.game.mechanic === 'reaction' ? PrecisionReaction
    : props.game.mechanic === 'search' ? PrecisionSearch
    : props.game.mechanic === 'sequence' || props.game.mechanic === 'grid' ? PrecisionMemory
    : props.game.mechanic === 'nback' ? PrecisionNBack
    : props.game.mechanic === 'maze' ? PrecisionMaze
    : props.game.mechanic === 'match' ? PrecisionMatch : PrecisionTracking;
  return <section className="precision-session">
    <div className="precision-session-header"><span><ShieldCheck size={14} /> {tierLabel(props.mode, props.tier)}</span><button onClick={() => { blocked.current = true; setInterrupted(true); }} aria-label="暂停本局"><Pause size={14} /> 暂停</button></div>
    {interrupted ? <div className="precision-intermission"><Pause size={30} /><h2>先休息一下</h2><p>已暂停。本局不记录、不领奖。为保证计时公平，继续时将重新开始本局。</p><button onClick={restart}><RotateCcw size={16} /> 重新开始本局</button></div>
      : count > 0 ? <div className="precision-intermission" role="status"><p>准备好，准确优先</p><strong className="precision-countdown" key={count}>{count}</strong><span><Play size={12} /> 即将开始{tierLabel(props.mode, props.tier)}</span></div>
      : <Game key={attempt} {...props} onComplete={(score, replay) => { if (!blocked.current) props.onComplete(score, replay); }} onFail={replay => { if (!blocked.current) props.onFail(replay); }} />}
  </section>;
}
